import {inject, Injectable} from "@angular/core";
import {PropertiesDialogDataSelect} from "@llm/service/utils_main_comp_variables.service";
import {Observable, of, switchMap} from "rxjs";
import {DataSelectComponent} from "@llm/dialogs/data-select/data-select.component";
import {MatDialog} from "@angular/material/dialog";
import {ClientService} from "@serv/client.service";
import {LlmSettingsAi} from '@llm/dialogs/settings_ai/settings-ai.component';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

@Injectable({providedIn: 'root'})
export class ToolsAiDialogsService {

  /**
   * Inyección de MatDialog utilizando la función `inject`.
   * utilizado para los dialogos visuales del Tools AI.
   */
  private _dialog = inject(MatDialog);

  private _tools_ai_client_service = inject(ClientService);
  private _console = inject(Tools_aiConsoleService);


  /**
   * Abre un diálogo para que el usuario seleccione un dato de una lista.
   * Utilizado cuando una búsqueda de datos devuelve múltiples resultados.
   * @param _data Array de objetos any para mostrar en el diálogo.
   * @returns Un Observable que emite el ID del dato seleccionado o el ID del dato por defecto.
   */
  openDataSelectionDialog(_data: PropertiesDialogDataSelect): Observable<string> {
    this._console.log("_data", _data);
    const dialogRef = this._dialog.open(DataSelectComponent, {
      width: '400px',
      data: _data
    });
    return dialogRef.afterClosed().pipe(
      switchMap(result => {
        if (result) {
          return of(result.toString());
        } else {
          return of('defaultItem');
        }
      })
    );
  }

  openSettingsAiDialog(): void {
    const dialogRef = this._dialog.open(LlmSettingsAi)
  }
}
